var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowNext = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64645 3.85355C3.45118 3.65829 3.45118 3.34171 3.64645 3.14645C3.84171 2.95118 4.15829 2.95118 4.35355 3.14645L8.85355 7.64645C9.04882 7.84171 9.04882 8.15829 8.85355 8.35355L4.35355 12.8536C4.15829 13.0488 3.84171 13.0488 3.64645 12.8536C3.45118 12.6583 3.45118 12.3417 3.64645 12.1464L7.79289 8L3.64645 3.85355ZM12 3.5C12 3.22386 11.7761 3 11.5 3C11.2239 3 11 3.22386 11 3.5V12.5C11 12.7761 11.2239 13 11.5 13C11.7761 13 12 12.7761 12 12.5V3.5Z",
    fill: "#262626"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowNext, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-next.faa01e67.svg";
export { ForwardRef as ReactComponent };